import { getChaveMenu } from '../../../utils/getChaveMenu'
import { Link } from 'react-router-dom'
import { NavBar, Search } from './styles'
import { useState } from 'react'
import AdvancedFilter from '../../lab/AdvancedFilter'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Drawer from '../../ElementsUI/Draw'
import Filters from './filters'
import Notification from '../../feedback/Notification'
import OficioService from '../../../services/OficioService'
import Popover from '@material-ui/core/Popover'
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state'
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined'
import TuneOutlinedIcon from '@material-ui/icons/TuneOutlined'
import UserDataComponent from '../../ElementsUI/UserData'
import { UserData } from '../../ElementsUI/UserData/styles'

export default function NavBarComponent({
    logoSistema,
    nomeSistema,
    notificacoes,
    ImgLogoTCEGO,
    dataMenus,
    displayFilter,
    setDisplayFilter,
    getSubMenu,
    setOficios,
    setOficiosFixados,
    setTotalPaginas,
    setPaginaAtual,
    setItensPorPagina,
    loading,
    setLoading,
    setError,
    setErrorMensagem,
    setEhPesquisa,
    match,
    showSearch,
    showActions
}) {

    const [filtroConsultaRapida, setFiltroConsultaRapida] = useState('');

    const aplicaFiltroConsultaRapida = (filtro) => {
        let parametrosConsultaAvancada = {};
        let parametroConsultaRapida = filtro;

        setLoading(true);
        OficioService.SubMenuComFiltroAvancado(1, 999, getChaveMenu(match.params.tipo), parametroConsultaRapida, parametrosConsultaAvancada)
            .then(response => {
                setOficios(response.data.itensNaoFixados);
                setOficiosFixados(response.data.itensFixados);
                setTotalPaginas(response.data.paginacao.totalPaginas);
                setPaginaAtual(response.data.paginacao.paginaAtual);
                setItensPorPagina(response.data.paginacao.itensPorPagina);
                setLoading(false);
                setError(false);
            })
            .catch(error => {
                setLoading(false);
                setOficios([]);
                setError(true);
                setErrorMensagem(error.response);
            })       
    }

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            aplicaFiltroConsultaRapida(event.target.value);
        }
    }

    const hanbleClickConsultaRapida = () => {        
        aplicaFiltroConsultaRapida(filtroConsultaRapida);
    }

    const handleLimparPesquisa = () => {
        setEhPesquisa(false)
        getSubMenu()
    }

    const FiltrosAvancados = () => <Filters
        match={match}
        getSubMenu={getSubMenu}
        setOficios={setOficios}
        setOficiosFixados={setOficiosFixados}
        setTotalPaginas={setTotalPaginas}
        setPaginaAtual={setPaginaAtual}
        setItensPorPagina={setItensPorPagina}
        loading={loading}
        setLoading={setLoading}
        setError={setError}
        setErrorMensagem={setErrorMensagem}
        handleLimparPesquisa={handleLimparPesquisa}
    />

    return (
        <>
            <NavBar id="NavBar">
                <NavBar.Content id="Content">
                    <NavBar.Full id="NavBar_Full">
                        <NavBar.Left id="NavBar_Left">
                            <Link to="/"><NavBar.Logo id="Logo"><NavBar.ImgLogo id="ImgLogo" src={logoSistema} /></NavBar.Logo></Link>
                        </NavBar.Left>
                        <NavBar.Center id="NavBar_Center">
                            {(showSearch) && (
                                <Search id="Search">
                                <Search.Box id="Search_Box">
                                    <Button className="btn-search" onClick={() => hanbleClickConsultaRapida()}><SearchOutlinedIcon /></Button>
                                    <Search.Input id="Search_Input"
                                        placeholder="Pesquisar ofícios"
                                        value={filtroConsultaRapida}
                                        onChange={e => setFiltroConsultaRapida(e.target.value)}
                                        onKeyPress={handleKeyDown} />
                                    <PopupState variant="popover" popupId="filter-search-bar">
                                        {(popupState) => (
                                            <>
                                                <button
                                                    id="btn-popover-filter-search-bar"
                                                    variant="contained"
                                                    color="primary" {...bindTrigger(popupState)}>                                                        
                                                    <Button
                                                        id="btn-inside-popover-filter-search-bar"
                                                        variant="contained"
                                                        color="primary">
                                                        <TuneOutlinedIcon />
                                                    </Button>                                                    
                                                </button>
                                                <button
                                                    id="btn-popover-filter-search-bar-close"
                                                    variant="contained"
                                                    color="primary" {...bindTrigger(popupState)}
                                                    onClick={popupState.close}>                                                                                                            
                                                </button>
                                                <Popover
                                                    {...bindPopover(popupState)}
                                                    anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'center',
                                                    }}
                                                    transformOrigin={{
                                                        vertical: 'top',
                                                        horizontal: 'center',
                                                    }}
                                                >
                                                    <Box p={2}>
                                                        <FiltrosAvancados />
                                                    </Box>
                                                </Popover>
                                            </>
                                        )}
                                    </PopupState>
                                </Search.Box>
                            </Search >
                            )}
                            
                        </NavBar.Center>
                        {(showActions) && (
                            <NavBar.Right id="NavBar_Right">                            
                                <NavBar.Actions id="Actions">
                                {(showSearch) && (
                                    <>
                                        <AdvancedFilter />
                                        <Notification />
                                    </>
                                )}
                                <UserDataComponent nomeSistema={nomeSistema} />
                                </NavBar.Actions>
                            </NavBar.Right>
                        )}
                        
                    </NavBar.Full>

                    <NavBar.Mobile id="NavBar_Mobile">
                        <NavBar.MobileBox id="NavBar_MobileBox">
                            <NavBar.MobileContent id="NavBar_MobileContent">
                                <NavBar.MobileLeft id="NavBar_MobileLeft">
                                    <Drawer
                                        nomeSistema={nomeSistema}
                                        ImgLogoTCEGO={ImgLogoTCEGO}
                                        dataMenus={dataMenus}
                                    />
                                </NavBar.MobileLeft>

                                {(showSearch) && (
                                    <NavBar.MobileCenter id="NavBar_MobileCenter">
                                        <Search.Input id="Search_Input" placeholder="Pesquisar ofícios" />
                                    </NavBar.MobileCenter>
                                )}                                

                                {(showSearch) && (
                                    <NavBar.MobileRight id="NavBar_MobileRight">
                                        <Button
                                            id="btn-inside-popover-filter-search-bar"
                                            variant="contained"
                                            color="primary"
                                            onClick={() => setDisplayFilter(!displayFilter)}
                                        >
                                            <TuneOutlinedIcon />
                                        </Button>
                                        <AdvancedFilter />
                                        <Notification />
                                        <UserData />
                                    </NavBar.MobileRight>
                                )}      
                            </NavBar.MobileContent>
                        </NavBar.MobileBox>
                    </NavBar.Mobile>

                </NavBar.Content>
            </NavBar>

            {
                displayFilter &&
                <NavBar.FilterBox id="NavBar_FilterBox">
                    <NavBar.FilterContent id="NavBar_FilterContent">
                        <FiltrosAvancados />
                    </NavBar.FilterContent>
                </NavBar.FilterBox>
            }
        </>
    )
}